import {global} from './lang';

export var Math = global.Math;
export var NaN = typeof NaN;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
